export enum UsageGaugeMetric {
    AnalyticsProperties = 'analytics.properties',
    Teams = 'teams',
    Users = 'users',
    Messages = 'messages',
    Sessions = 'sessions',
    Databases = 'databases',
    Collections = 'collections',
    Documents = 'documents',
    DatabasesStorage = 'databases.storage',
    DocumentsdbDatabases = 'documentsdb.databases',
    DocumentsdbCollections = 'documentsdb.collections',
    DocumentsdbDocuments = 'documentsdb.documents',
    DocumentsdbDatabasesStorage = 'documentsdb.databases.storage',
    VectorsdbDatabases = 'vectorsdb.databases',
    VectorsdbCollections = 'vectorsdb.collections',
    VectorsdbDocuments = 'vectorsdb.documents',
    VectorsdbDatabasesStorage = 'vectorsdb.databases.storage',
    Buckets = 'buckets',
    Files = 'files',
    FilesStorage = 'files.storage',
    Sites = 'sites',
    Functions = 'functions',
    Deployments = 'deployments',
    DeploymentsStorage = 'deployments.storage',
    Builds = 'builds',
    BuildsStorage = 'builds.storage',
    UsersMau = 'users.mau',
    UsersDau = 'users.dau',
    UsersWau = 'users.wau',
    Webhooks = 'webhooks',
    Platforms = 'platforms',
    Providers = 'providers',
    Topics = 'topics',
    Targets = 'targets',
    Keys = 'keys',
    Domains = 'domains',
    RealtimeConnections = 'realtime.connections',
    BackupsPolicies = 'backups.policies',
    BackupsStorage = 'backups.storage',
    DedicatedDatabasesStorage = 'dedicatedDatabases.storage',
    DedicatedDatabasesConnections = 'dedicatedDatabases.connections',
    DedicatedDatabasesCpu = 'dedicatedDatabases.cpu',
    DedicatedDatabasesMemory = 'dedicatedDatabases.memory',
    DedicatedDatabasesQps = 'dedicatedDatabases.qps',
    DedicatedDatabasesIopsRead = 'dedicatedDatabases.iopsRead',
    DedicatedDatabasesIopsWrite = 'dedicatedDatabases.iopsWrite',
    Apps = 'apps',
    AppsUsers = 'apps.users',
    AppsInstallations = 'apps.installations',
}
